module.exports = __webpack_public_path__ + "img/common-badge.201b6df4.png";